<div (click)="onClick()"
     [class.active]="isActive || soType === activeSo"
     [class.disabled]="isDisabled"
     [style.margin-top.px]="withTopMargin ? 24 : 0"
     class="sm__icon"
     matTooltip="{{ttText}}"
     matTooltipPosition="left">
  <ng-content></ng-content>
</div>
